import { FunctionComponent, useEffect, useState } from "react";

import { InputSwitch } from "primereact/inputswitch";

interface ISettingCheckboxInputProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export const SettingCheckboxInput: FunctionComponent<ISettingCheckboxInputProps> = (
  props: ISettingCheckboxInputProps,
) => {
  const [value, setValue] = useState<boolean>(props.value);

  useEffect(() => {
    if (props.value !== value) {
      setValue(props.value);
    }
  }, [props.value]);

  const onTextInputChange = (value: boolean) => {
    setValue(value);

    props.onChange(value);
  };

  return <InputSwitch onChange={event => onTextInputChange(event.target.value)} checked={value} />;
};
